import { AuthContext, useApi } from '@repo-level/core-front';
import type { IMissionBlock, IMissions } from 'api/cms/missions';
import { getMissionsCMS } from 'api/cms/missions';
import { filterByGroups } from 'helpers/cms';
import { useContext, useMemo } from 'react';

export const useMissionsCMS = () => {
  const { user } = useContext(AuthContext);
  const [requestMissions, { error, pending, data }] = useApi(getMissionsCMS);

  const filteredData = useMemo((): IMissions | null => {
    if (!data) return null;

    const filteredMissionsBlocks = data.missionsBlocks
      ? filterByGroups<IMissionBlock>({ user })(data.missionsBlocks)
      : [];

    return { ...data, missionsBlocks: filteredMissionsBlocks };
  }, [data, user]);

  return {
    data: filteredData,
    error: !!error,
    pending,
    requestMissions,
  };
};
